import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {UserFactory} from "../../../models/User";
import {DialogService} from "../dialog/dialog.service";

@Component({
   selector: 'app-change-password',
   templateUrl: './change-password.component.html',
   styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

   @Output() changePwdComplete = new EventEmitter<boolean>();

   pwdFrm: UntypedFormGroup = new UntypedFormGroup({
      password: new UntypedFormControl('', Validators.required),
      confirm_password: new UntypedFormControl('', Validators.required),
   }, { validators: this.checkPasswords });

   public hidepw = true;
   public hidepw2 = true;

   constructor(private userFactory:UserFactory,
               private dialogSrv: DialogService) { }

   ngOnInit(): void {
   }

   checkPasswords(control: AbstractControl) {
      const password = control.get('password');
      const confirm_password = control.get('confirm_password');
      let has_err = password && confirm_password && password.value !== confirm_password.value ? { not_same_pswd: true } : null;
      if (has_err) confirm_password?.setErrors({not_same_pswd: true});
      else confirm_password?.setErrors(null);
      return has_err;
   };

   async clickCambioPsw(user_id, esercizio_slug=null) {
      if(this.pwdFrm.valid){
         this.userFactory.setPassword( user_id, this.pwdFrm.value["password"], esercizio_slug).then(res=>{
            this.changePwdComplete.emit()
            // this.dialogSrv.closeAll();
            // this.dialogSrv.showToastSuccess({title:"Cambio password", msg:"Password cambiata con successo"})
         }).catch(err=>{
            this.dialogSrv.closeAll();
            this.dialogSrv.showToastError({typeDialog:"error", err: err, title:"Impossibile cambiare la password"})
         })
      }else{
         this.pwdFrm.markAllAsTouched()
      }
   }

}
